<template>
  <div class="member-order-list">
    <gobuy-head title="Card List" />
    <div class="zhanweifu" style="height: 4.2rem;" v-if="!$IFR.is_iframe"></div>
    <!-- <div class="common-header-wrap">
            <div class="common-header">
                <mt-button class="back" slot="left" icon="back" @click="$router.go(-1)"></mt-button>
                <div class="common-search">
                    <input type="text" v-model="keyword" :placeholder="$t('orderSearch')" @keyup.enter="handleEnter"
                        @input="reset">
                </div>
                <div class="btn" @click="handleEnter">{{ $t('Search') }}</div>
            </div>
        </div> -->
    <body>
      <div style="padding-bottom: 150px">
        <div class="search">
          <div class="l">
            <div class="icon">
              <img src="../../../assets/image/home/Search.png" alt="" />
            </div>
            <input
              type="text"
              v-model="keyword"
              :placeholder="$t('orderSearch')"
              @keyup.enter="handleEnter"
            />
          </div>
          <div class="search1 button" @click="handleEnter">
            <img
              src="../../../assets/image/home/icon_search.png"
              style="width: 20px; height: 20px"
              alt=""
            />
          </div>
        </div>

        <!-- header -->
        <div class="order-header">
          <ul ref="tagBar">
            <li
              class="item tag"
              v-for="item in orderNav"
              v-bind:key="item.id"
              v-bind:class="{ active: stateType == item.id }"
              v-on:click="setOrderNavActive(item.id)"
            >
              {{ item.name }}
            </li>
          </ul>
        </div>
        <div
          v-infinite-scroll="loadMore"
          infinite-scroll-disabled="loading"
          infinite-scroll-distance="10"
        >
          <div
            class="order-body"
            v-if="order_group_list && order_group_list.length"
          >
            <!-- <div v-for="(order_group, index) in order_group_list" v-bind:key="index"> -->

            <div
              class="list"
              v-for="item in order_group_list"
              :key="item.id"
              @click="gotoDetail(item.id)"
            >
              <!-- <div @click="gotoDetail(item.id)"> -->
              <div class="tips-body">
                <span class="tips"
                  >{{ $t("OrderNo") }}: {{ item.order_sn }}</span
                >
                <span
                  class="tips statusTips copy button"
                  @click.stop="copySuccess(item.order_sn)"
                >
                  {{ $t("Copy") }}
                </span>
                <!-- <span class="title tips statusTips">
                                      {{
                                          item.status == 1 ? $t('Verifying') :
                                          item.status == 2 ? $t('Rebuying') :
                                              item.status == 3 ? $t('Repurchased') :
                                                  item.status == 4 ? $t('Paid') : $t('Unknown')
                                      }}
                                  </span> -->
              </div>

              <div class="order-image">
                <div class="goods_info clearfix">
                  <!-- <div class="img">
                                  <img v-bind:src="item.img" />
                                  </div> -->
                  <div class="goods_name">{{ item.title }}</div>
                  <div class="goods_price">
                    <div class="price">${{ item.price }}</div>
                    <div class="num">X{{ 1 }}</div>
                  </div>
                </div>
              </div>

              <!-- <div class="number-code">
                                  <div class="nci">
                                      <div class="tit">{{ $t('Card number') }}:
                                          <div class="cc">
                                              <div class="c">{{ item.card }}</div>
                                          </div>
                                      </div>
                                      <div class="copy" @click.stop="copySuccess(item.card)">{{ $t('Copy') }}</div>
                                  </div>
                                  <div class="nci">
                                      <div class="tit">{{ $t('Activation code') }}:
                                      </div>
                                      <div class="cc">
                                          <div class="c">{{ item.code }}</div>
                                          <span class="copy" @click.stop="copySuccess(item.code)">copy</span>
                                      </div>
                                  </div>
                              </div> -->
              <div
                class="order_amount"
                style="
                  height: auto;
                  text-wrap: wrap;
                  line-height: 1rem;
                  padding: 0.5rem;
                  text-align: left;
                "
                v-if="item.reason"
              >
                {{ $t("Cause of failure") }}:{{ item.reason }}
              </div>
              <div class="order_amount">
                <!-- {{ $t('Face Value Total') }}: -->
                <div class="t">
                  {{
                    item.status == 1
                      ? $t("Verifying")
                      : item.status == 2
                      ? $t("Rebuying")
                      : item.status == 3
                      ? $t("Repurchased")
                      : item.status == 4
                      ? $t("Paid")
                      : $t("Unknown")
                  }}:
                </div>
                <div class="p">
                  <i class="order_amount_icon">$</i>
                  <i class="i">{{ item.back_price }}</i>
                </div>
                <!-- <i class="i freight">(Shipping:${{ item.shipping_fee }})</i> -->
              </div>
              <!-- </div> -->
            </div>

            <!-- Independent button for payment involving multiple stores merged -->
            <!-- <div v-if="order_group.pay_amount && order_group.pay_amount > 0"
                          class="common-btn ds-button-large mt-5 mb-5" @click="pay(order_group.pay_sn)">
                        Pay
                      </div> -->

            <!-- </div> -->
          </div>
          <div
            class="empty"
            v-else-if="order_group_list && !order_group_list.length"
          >
            <empty-record></empty-record>
          </div>
        </div>
      </div>
    </body>
  </div>
</template>

<script>
import {
  getGiftList,
  getBoxList,
  cancelOrder,
  addBoxSave,
  receiveOrder,
  deleteOrder,
} from "../../../api/memberOrder";
import { Toast, MessageBox, Indicator } from "mint-ui";
import { mapState } from "vuex";
import EmptyRecord from "../../../components/EmptyRecord";
export default {
  components: {
    EmptyRecord,
  },
  name: "MemberOrderList",
  data() {
    return {
      order_id: 0,
      status: null,
      keyword: this.$route.query.keyword ? this.$route.query.keyword : "", // 关键字
      orderNav: [
        {
          name: this.$t("All"),
          id: null,
        },
        {
          name: this.$t("Verifying"),
          id: "1",
        },
        {
          name: this.$t("Rebuying"),
          id: "2",
        },
        {
          name: this.$t("Repurchased"),
          id: "3",
        },
        {
          name: this.$t("Paid"),
          id: "4",
        },
      ],
      stateType: this.$route.query.state ? this.$route.query.state : null,
      orderDetailVisible: false,
      wrapperHeight: 0,
      params: { page: 0, per_page: 10 },
      loading: false, // 是否加载更多
      isMore: true, // 是否有更多
      order_group_list: false,
    };
  },

  mounted() {
    window.scrollTo(0, 0);
    this.wrapperHeight = document.documentElement.clientHeight - 140;
  },
  computed: {
    ...mapState({
      user: (state) => state.member.info,
    }),
  },
  created: function () {
    // this.getOrderList(true)
  },

  methods: {
    reset() {
      if (this.keyword != "") return;
      this.getOrderList(true);
    },
    handleEnter() {
      // if (!this.keyword) return
      this.getOrderList(true);
    },
    gotoDetail(id) {
      // :to="'/member/gift_detail?order_id=' + item.id"
      this.$router.push({ name: "GiftBoxDetail", query: { order_id: id } });
    },
    copySuccess(sn) {
      this.$copyText(sn).then(
        (e) => {
          Toast(this.$t("succ"));
          // console.log(e);
        },
        (e) => {
          Toast(this.$t("err"));
          // console.log(e);
        }
      );
    },
    goOrderSearch() {
      this.$router.push({ name: "MemberOrderSearch" });
    },
    setOrderNavActive(index) {
      this.stateType = index;
      this.getOrderList(true);
      this.centerTag(index);
    },
    centerTag(index) {
      const tagElements = this.$refs.tagBar.getElementsByClassName("tag");
      if (tagElements.length > 0) {
        const selectedTag = tagElements[index];
        const tagBar = this.$refs.tagBar;

        if (!selectedTag) return;
        // 计算需要滚动的距离
        const scrollTo =
          selectedTag.offsetLeft +
          selectedTag.offsetWidth / 2 -
          tagBar.offsetWidth / 2;

        // 设置平滑滚动
        tagBar.scrollTo({
          left: scrollTo,
          behavior: "smooth",
        });
      }
    },
    showMessage(message, title) {
      MessageBox.alert(message, title);
    },
    deleteOrder(orderInfo) {
      MessageBox.confirm("确定要删除该订单吗？").then((action) => {
        deleteOrder(orderInfo.order_id)
          .then((res) => {
            this.getOrderList(true);
          })
          .catch(function (error) {
            Toast(error.message);
          });
      });
    },
    cancel(orderInfo) {
      MessageBox.confirm("确定要回收该盲盒吗？").then((action) => {
        addBoxSave(orderInfo.id)
          .then((res) => {
            Toast(res.message);
            // this.getOrderList(true)
            this.setOrderNavActive(3);
          })
          .catch(function (error) {
            Toast(error.message);
          });
      });
    },
    receive(orderId) {
      MessageBox.confirm("确定该订单已收货吗？").then((action) => {
        receiveOrder(orderId)
          .then((res) => {
            this.getOrderList(true);
          })
          .catch(function (error) {
            Toast(error.message);
          });
      });
    },
    deliver(orderId) {
      this.$router.push({
        name: "MemberOrderDeliver",
        query: { order_id: orderId },
      });
    },
    goRefund(refundId) {
      this.$router.push({
        name: "MemberRefundView",
        query: { refund_id: refundId },
      });
    },
    refund(orderId) {
      this.$router.push({
        name: "MemberRefundForm",
        query: { order_id: orderId },
      });
    },
    evaluate(orderId) {
      this.$router.push({
        name: "MemberOrderEvaluate",
        params: { order_id: orderId },
      });
    },
    pay(paySn) {
      this.$router.push({
        name: "MemberBuyPay",
        query: { pay_sn: paySn, pay_type: "pay_new" },
      });
    },
    getOrderInfo(orderId) {
      this.orderDetailVisible = true;
      this.order_id = orderId;
    },
    loadMore() {
      this.loading = true;
      this.params.page = ++this.params.page;
      console.log(this.isMore);
      if (this.isMore) {
        this.loading = false;
        this.getOrderList(false);
      }
    },
    getOrderList(ifReplace) {
      Indicator.open();
      if (ifReplace) {
        this.loading = false;
        this.params.page = 1;
        this.isMore = true;
      }

      getGiftList(
        this.params,
        this.stateType,
        "",
        this.keyword,
        this.stateType,
        this.keyword
      )
        .then((res) => {
          Indicator.close();
          if (res.result.current_page !== res.result.last_page) {
            this.isMore = true;
          } else {
            this.isMore = false;
          }

          // let tOrderGroup = res.result.order_group_list
          let tOrderGroup = res.result.data;

          if (tOrderGroup) {
            if (ifReplace || !this.order_group_list) {
              this.order_group_list = tOrderGroup;
            } else {
              this.order_group_list = this.order_group_list.concat(tOrderGroup);
            }
          }
        })
        .catch(function (error) {
          Indicator.close();
          Toast(error.message);
        });
    },
  },
};
</script>
<style lang="scss" scoped>
body {
  width: 100%;
  background-color: transparent;
  // position: fixed;
  top: 100px;
  height: 100vh;
  // overflow-y: auto;
}
.search {
  margin: 0.5rem 12px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  background: #f9f9f9;
  border-radius: 50px 50px 50px 50px;
  padding: 0.3rem 12px;

  .l {
    flex: 1;
    display: flex;
    align-items: center;
    justify-content: space-between;

    .icon {
      width: 0.7rem;
      height: 0.7rem;
      margin-right: 0.3rem;

      img {
        width: 100%;
        height: 100%;
        display: block;
      }
    }
  }

  .search1 {
    background: linear-gradient(90deg, #e8090c 0%, #f3611e 100%);
    border-radius: 50px;
    color: #fff;
    // padding: 0 10px;
    font-size: 0.6rem;
    height: 1rem;
    line-height: 1rem;
    margin-left: 10px;
    padding: 4px 8px;
  }

  input {
    box-sizing: border-box;
    width: 100%;
    height: 1.6rem;
    border-radius: 10px;
    background-size: 0.55rem;
    font-size: 0.6rem;
    color: #000000;
    background: #f9f9f9;
    // padding-left: 1.6rem;
    border: 0;
  }
}

.member-order-list {
  min-height: 100vh;
  // background: RGBA(240, 240, 240, 1);

  .back {
    background-color: #fff;
    box-shadow: none;
  }
  .logo_box {
    position: fixed;
    top: 25px;
    left: 12px;
    z-index: 99;

    img {
      width: 3.5rem;
    }
  }
  .common-header-wrap {
    position: fixed;
    top: 54px;
    width: 100%;
    .common-header {
      background: rgba(232, 9, 12, 0.6) !important;
      color: #fff;
      box-shadow: none;
      /* 平滑过渡效果 */
    }
  }
  .common-header {
    display: flex;
    align-items: center;
    line-height: normal;
    // padding: .1rem 0;
    box-shadow: none;

    .btn {
      padding: 0.2rem;
      margin: 0 0.4rem 0 0;
      font-size: 0.7rem;
      border-radius: 10px;
      color: #fff;
      background: #fb2630;
    }
  }

  .common-search {
    padding: 0;
    padding-left: $pageSpace;
    padding-right: 0.2rem;
    flex: 1;

    input {
      box-sizing: border-box;
      width: 100%;
      height: 1.6rem;
      border-radius: 1.6rem;
      background: #f4f4f4 url(../../../assets/image/home/icon_search.png)
        no-repeat 0.6rem center;
      background-size: 0.55rem;
      font-size: $fontSize;
      color: #999;
      padding-left: 1.6rem;
      border: 0;
    }
  }

  .order-header {
    // position: fixed;
    height: 2rem;
    width: 100%;
    top: 2rem;
    z-index: 100;
    box-sizing: border-box;
    padding: 0 0.4rem;
    overflow: hidden;
    // background: rgba(255, 255, 255, 1);

    ul {
      scroll-snap-type: x mandatory;
      -webkit-overflow-scrolling: touch;
      /* iOS 平滑滚动 */
      list-style: none;
      width: auto;
      // display: flex;
      // justify-content: space-around;
      // align-content: center;
      // align-items: center;
      width: 100%;
      overflow: hidden;
      overflow-x: auto;
      white-space: nowrap;
      height: 100%;
      border-bottom: 1px solid #e8eaed;
      -ms-overflow-style: none;
      /* IE and Edge */
      scrollbar-width: none;
      /* Firefox */

      &::-webkit-scrollbar {
        display: none;
        /* Chrome, Safari, Opera*/
      }

      li {
        box-sizing: border-box;
        margin: 0 0.2rem;
        padding: 0rem 0.6rem;
        display: inline-block;
        font-size: 16px;
        font-weight: bold;
        color: #666666;
        text-align: center;
        line-height: 1rem;
        border-bottom: 0.1rem solid transparent;

        &.active {
          color: #000;
          padding: 0rem 0.7rem;
          border-bottom: none; /* 取消默认下划线 */

          /* 使用图片作为背景 */
          background-image: url("../../../assets/image/underline.png"); /* 替换为你的图片路径 */

          /* 设置背景图片的大小（固定宽度和高度） */
          background-size: 50px 5px; /* 100px 宽，5px 高，这里宽度固定为 100px，高度固定为 5px */

          /* 确保背景图片不重复 */
          background-repeat: no-repeat;

          /* 将背景图片位置设置为底部居中 */
          background-position: left 10px bottom; /* 水平居中，垂直对齐底部 */

          /* 让文字自适应下划线 */
          display: inline-block; /* 让元素行为更像块级元素，这样下划线可以居中 */
        }
      }
    }
  }

  .order-body {
    position: relative;
    padding: 0.4rem 0.5rem;
    // background-color: #fff;
    .list {
      width: 100%;
      padding: 0.7rem 0.6rem;
      box-sizing: border-box;
      margin-bottom: 1rem;
      background: #fafafa;
      border-radius: 10px 10px 10px 10px;

      .tips-body {
        // height: 2.2rem;
        // background: rgba(255, 255, 255, 1);
        // box-shadow: 0 0.5px 0 0 rgba(232, 234, 237, 1);
        display: flex;
        justify-content: space-between;
        padding: 0 0 0.6rem;
        border-bottom: 1px solid #dedede;

        .tips {
          font-size: 0.6rem;
          color: #7d7d7d;
          // line-height: 2.2rem;
        }

        .statusTips {
          color: $primaryColor;
        }

        .copy {
          font-weight: 600;
          margin: 0 0;
          font-size: 0.6rem;
        }

        img {
          width: 3.8rem;
          height: 3rem;
        }
      }

      .order-image {
        // height: 4.55rem;
        // background: rgba(250, 250, 250, 1);
        width: 100%;
        overflow: hidden;
        overflow-x: auto;
        white-space: nowrap;

        .goods_info {
          height: 3rem;
          display: flex;
          align-items: center;
          // padding-left: $pageSpace;
          // padding-right: $pageSpace;

          .img {
            width: 3rem;
            height: 3rem;
            margin: 0.85rem 0.3rem 0.5rem;

            img {
              width: 3rem;
              height: 3rem;
              border-radius: 1px;
            }
          }

          .goods_name {
            white-space: normal;
            overflow: hidden;
            height: 2rem;
            width: 10rem;
            font-size: 0.7rem;
            font-weight: 600;
            color: #333;
          }

          .goods_price {
            margin-left: auto;
            padding-right: 0.75rem;
            text-align: right;

            .price {
              font-size: $subFontSize;
              color: rgba(78, 84, 93, 1);
            }

            .num {
              font-size: 0.6rem;
              color: #999;
              padding-top: 0.3rem;
            }
          }
        }
      }

      .multiple {
        .imagebox {
          width: 100%;
          overflow-x: auto;
          white-space: nowrap;

          img {
            width: 3rem;
            height: 3rem;
            margin: 0.85rem 0.3rem 0.5rem;
            display: inline-block;
          }
        }
      }

      .number-code {
        font-size: $subFontSize;
        color: rgba(78, 84, 93, 1);
        background-color: #fff;

        .nci {
          height: 2rem;
          padding: 0 0.75rem;
          border-bottom: 1px solid #e8eaed;
          display: flex;
          justify-content: space-between;
          align-items: center;

          .tit {
            margin-bottom: 0.1rem;
            display: flex;
            justify-content: space-between;
            align-items: center;
          }

          .cc {
            padding: 0 0.1rem;
          }

          .copy {
            color: $primaryColor;
            font-weight: 600;
          }
        }
      }

      .order_amount {
        font-size: $subFontSize;
        color: rgba(78, 84, 93, 1);
        // line-height: 2.2rem;
        // height: 2.2rem;
        // background-color: #fff;
        padding: 0 0.5rem;
        // border-bottom: 1px solid #e8eaed;
        box-sizing: border-box;
        text-align: right;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
        display: flex;
        justify-content: flex-end;
        align-items: center;
        color: $primaryColor;
        font-weight: 600;

        .order_amount_icon {
          font-size: $subFontSize;
          color: $primaryColor;
        }

        i {
          font-size: $h2;
          color: $primaryColor;
          padding-left: 0.15rem;
          font-style: normal;

          &.freight {
            color: #333;
            font-size: $fontSize;
          }
        }
      }
    }

    .loading-wrapper {
      text-align: center;

      p {
        color: #c3c3c3;
        font-size: $fontSize;
        margin: 0.5rem auto;
      }
    }
  }

  .mint-popup {
    width: 100%;
    height: 11.75rem;
  }
}

.order-list-opratio {
  height: 2.2rem;
  display: flex;
  justify-content: flex-end;
  background: rgba(255, 255, 255, 1);
  border-radius: 0.1rem;
}

.order-list-opratio button {
  width: 4.5rem;
  height: 1.5rem;
  font-size: $subFontSize;
  border-radius: 0.7rem;
  margin: 0.35rem 0.75rem 0.35rem 0;
  background-color: #fff;
  border: 1px solid #ccc;
  box-shadow: 0 3px 6px 0 rgba(0, 0, 0, 0.05);
}

.order-list-opratio .line_red {
  background-color: #fff;
  color: #f2270c;
  border: 1px solid #f2270c;
  box-shadow: 0 3px 6px 0 rgba(242, 39, 12, 0.1);
}

.ds-button-large {
  margin: 0 $pageSpace;
}
.empty {
  padding: 0px 12px;
}
</style>
